<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="tabela.busca" v-if="!addUser" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc
      class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">Empresas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text @click="addEmpresa" tile color="#5b3a4b">
            <v-icon left dark>add_circle</v-icon>Cadastrar
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:[`item.cor`]="{ item }">
        <v-card :color="item.cor">
          <p :style="`color:${item.cor}; margin: 0px`">{{ item.cor }}</p>
        </v-card>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma Empresa
              encontrada</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por
              "{{ tabela.busca }}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template v-if="adicionarEmpresas">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="9" lg="9">
                <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="CNPJ*" v-mask="'##.###.###/####-##'" outlined dense hide-details
                  v-model="editedItem.cnpj"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="Endereço*" outlined dense hide-details
                  v-model="editedItem.endereco"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="Telefone" v-mask="'(##) #####-####'" outlined dense hide-details
                  v-model="editedItem.telefone"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="E-mail" outlined dense hide-details v-model="editedItem.email"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="Capacidade" outlined dense hide-details
                  v-model="editedItem.capacidade"></v-text-field>
              </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="porcentagem" outlined dense hide-details
                  v-model="editedItem.porcentagem"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="Canal WS" outlined dense hide-details
                  v-model="editedItem.canalWS"></v-text-field>
              </v-col> 
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-text-field label="chavePix" outlined dense hide-details
                  v-model="editedItem.chavePix"></v-text-field>
              </v-col> 
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-text-field label="Logo URL*" outlined dense hide-details
                  v-model="editedItem.logoUrl"></v-text-field>
                <v-img contain :src="editedItem.logoUrl" height="100" width="100%" v-if="editedItem.logoUrl"
                  style="max-width: 100%; max-width: 130px; margin-top: 10px" class="mx-auto"></v-img>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-text-field label="Avatar URL" outlined dense hide-details
                  v-model="editedItem.avatarUrl"></v-text-field>
                <v-img contain :src="editedItem.avatarUrl" height="100" width="100%" v-if="editedItem.avatarUrl"
                  style="max-width: 100%; max-width: 130px; margin-top: 10px" class="mx-auto"></v-img>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="4" lg="3">
                <v-switch inset v-model="editedItem.enviaWhatspp" label="Envio Whatspp"
                  style="white-space: nowrap"></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="4" lg="3">
                <v-switch inset v-model="editedItem.enviaSMS" label="enviaSMS" style="white-space: nowrap"></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="4" lg="3">
                <v-switch inset v-model="editedItem.enviaEmail" label="enviaEmail"
                  style="white-space: nowrap"></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="4">
                <v-text-field label="Token WhatsApp" outlined dense hide-details
                  v-model="editedItem.tokenWhatsApp"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="4">
                <v-text-field label="Token Asaas" outlined dense hide-details
                  v-model="editedItem.tokenAsaas"></v-text-field>
              </v-col>
               <v-col cols="12" xs="12" sm="12" md="3" lg="4">
                <v-text-field label="idAsaas" outlined dense hide-details
                  v-model="editedItem.idAsaas"></v-text-field>
              </v-col>
               <v-col cols="12" xs="12" sm="12" md="3" lg="4">
                <v-text-field label="urlCardapio" outlined dense hide-details
                  v-model="editedItem.urlCardapio"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-text-area label="urlImgConfirmacaoPagamento" outlined dense hide-details
                  v-model="editedItem.urlImgConfirmacaoPagamento"></v-text-area>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-textarea label="msgConfirmacaoPagamento" outlined hide-details
                  v-model="editedItem.msgConfirmacaoPagamento"></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-textarea label="Msg PagamentoRecusado" outlined hide-details
                  v-model="editedItem.msgPagamentoRecusado"></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-textarea label="Msg PagamentoPendente" outlined hide-details
                  v-model="editedItem.msgPagamentoPendente"></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-textarea label="Msg ChekinEfetuado" outlined hide-details
                  v-model="editedItem.msgChekinEfetuado"></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-textarea label="Msg LembreteChekinAntecipado" outlined hide-details
                  v-model="editedItem.msgLembreteChekinAntecipado"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="salvarEmpresas">Salvar</v-btn>
          <v-btn color="#BA68C8" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  components: { Snackbar, Loading },
  data: () => ({
    fullPage: true,
    isLoading: false,
    addUser: false,
    adicionarEmpresas: false,
    temInscritos: false,
    tabela: {
      busca: '',
      cabecalho: [
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'CNPJ', value: 'cnpj' },
        { text: 'Endereço', value: 'endereco' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      conteudo: []
    },
    editedIndex: -1,
    editedItem: {
      nome: '',
      cnpj: '',
      endereco: '',
      telefone: '',
      Capacidade: '',
      canalWS: '',
      idAsaas: '',
      logoUrl: '',
      avatarUrl: '',
      chavePix: '',
      porcentagem: '',
      enviaWhatspp: true,
      enviaSMS: true,
      enviaEmail: true,
      urlImgConfirmacaoPagamento: '',
      tokenWhatsApp: '',
      tokenAsaas: '',
      msgConfirmacaoPagamento: '',
      msgPagamentoRecusado: '',
      msgPagamentoPendente: '',
      msgChekinEfetuado: '',
      msgLembreteChekinAntecipado: '',
    },
    defaultItem: {
    nome: '',
      cnpj: '',
      endereco: '',
      telefone: '',
      Capacidade: '',
      canalWS: '',
      idAsaas: '',
      logoUrl: '',
      avatarUrl: '',
      chavePix: '',
      porcentagem: '',
      enviaWhatspp: true,
      enviaSMS: true,
      enviaEmail: true,
      urlImgConfirmacaoPagamento: '',
      tokenWhatsApp: '',
      tokenAsaas: '',
      msgConfirmacaoPagamento: '',
      msgPagamentoRecusado: '',
      msgPagamentoPendente: '',
      msgChekinEfetuado: '',
      msgLembreteChekinAntecipado: '',
    },
    eventos: [],
    eventoId: '',
    eventoIdAtual: '',
    redes: [],
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR NOVA EMPRESA ' : 'EDITAR EMPRESA'
    }
  }),

  mounted() {
    this.carregaEmpresas()
  },

  methods: {
    async carregaEmpresas() {
      this.isLoading = true
      await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          }
        })
    },

    async addEmpresa() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.addUser = true;
      this.adicionarEmpresas = true;
    },

    editItem(item) {
      this.editedIndex = this.tabela.conteudo.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.addUser = true
      this.adicionarEmpresas = true
    },


    async salvarEmpresas() {
      var vm = this;

      if (this.editedItem.nome || this.editedItem.cnpj || this.editedItem.endereco) {
        this.isLoading = true

        await axios.post(baseApiUrl + 'Empresas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false

              this.close()
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaEmpresas();
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE")
          })
      } else {
        vm.$refs.chamaSnackbar.snack("F9A825", "Preencha os campos para prosseguir", "ATENÇÃO")
      }
    },

    async close() {
      this.addUser = false;
      this.adicionarEmpresas = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    async deleteItem(item) {
      let vm = this
      let r = confirm('Realmente deseja EXCLUIR a EMPRESA ' + item.nome + '?')

      if (r == true) {
        try {
          await axios.delete(baseApiUrl + 'Empresas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")

          this.$nextTick(() => {
            this.carregaEmpresas()
          });

        } catch (error) {
          console.error("Erro ao deletar empresa:", error);
          vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE");
        }
      }
    }
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style> ai cheff